import styled from "styled-components";
import { useHistory } from "react-router-dom";

import OrderDetail from "components/containers/commerce/order/OrderDetail";

import TitleHeader from "components/presenters/header/TitleHeader";

export default function OrderDetailLayout({ orderNo }) {
  const history = useHistory();
  return (
    <Wrapper>
      <HeaderBlock>
        <TitleHeader
          title={"주문상세"}
          onBackBtn={() => history.replace("/mypage")}
          isCloseBtn
        />
      </HeaderBlock>
      <Content>
        <OrderDetail orderNo={orderNo} />
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

const HeaderBlock = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (59.68 / 375));
  height: calc(100vw * (60 / 375));
`;

const Content = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow-y: scroll;
  padding-bottom: calc(100vw * (50 / 375));
`;
